import { GridLayoutHeader } from '../../../../../constants';
import { FlexLayout } from '../../../../../components/layout/FlexLayout';
import { BreakSituationActModel } from '../models';
import { BreakSituation } from '../BreakSituation';
import { CircleBadge } from '../../../../../components';
import { Sum } from '../../../../../utils/array';
import { Format } from '../../../../../utils/string';
import { Date8 } from '../../../../../utils/time';

// 현장호기별

const contgubuns = [
  { value: '01', remark: 'FM계약' },
  { value: '02', remark: '다년계약' },
  { value: '03', remark: '일반계약' },
  { value: '04', remark: '상주' },
  { value: '05', remark: '외주' },
];
const Act: GridLayoutHeader<BreakSituationActModel, BreakSituation>[] = [
  {
    id: 'recedate',
    text: '접수일자',
    width: 100,
    trail: () => (
      <FlexLayout
        justify="center"
        align="center"
      >
        총 계
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="gencer"
      >
        {Date8.withDash(x.recedate)}
      </FlexLayout>
    ),
  },
  {
    id: 'recetime',
    text: '접수시간',
    width: 80,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.recetime.substr(0, 2)}:{x.recetime.substr(2, 2)}
      </FlexLayout>
    ),
  },
  {
    id: 'actnm',
    text: '현장명',
    width: 170,
    group: true,
    sum: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.actnm}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.actnm}
      </FlexLayout>
    ),
  },
  {
    id: 'equpnm',
    text: '호기명',
    width: 120,
    group: true,
    sum: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.equpnm}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.equpnm}
        <CircleBadge>
          {Number(x.wadcnt) > 1 && <span
            style={{ backgroundColor: 'var(--color-red)' }}
          >
            {Number(x.wadcnt) > 1 ? x.wadcnt : ''}
          </span>}
          {Number(x.lastcnt) > 1 && <span
            style={{ backgroundColor: 'var(--color-blue)' }}
          >
            {Number(x.lastcnt) > 1 ? x.lastcnt : ''}
          </span>}
        </CircleBadge>
      </FlexLayout>
    ),
  },
  {
    id: 'planstate',
    text: '점검완료',
    width: 80,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
        style={{ color: x.planstate === '1' ? 'var(--color-red)' : 'var(--color-blue)' }}
      >
        {x.planstate === '1' ? '미처리'
          : x.planstate === '2' ? '완료' : ''}
      </FlexLayout>
    ),
  },
  {
    id: 'repernm',
    text: '접수자',
    width: 80,
    sum: (x, data) => {
      const sumSeq = Sum.groupLength(data, 'seq', x, ['actnm']);
      return (
        <FlexLayout
          justify="center"
          align="center"
        >
          접수: {Format.number(sumSeq)} 건
        </FlexLayout>
      );
    },
    trail: (_, scope) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {scope?.state.rececnt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.repernm}
      </FlexLayout>
    ),
  },
  {
    id: 'actpernm',
    text: '담당자',
    width: 80,
    sum: (x, data) => {
      const sumSeq = Sum.groupValue(data, 'seq', x, '1', ['actnm']);
      return (
        <FlexLayout
          justify="center"
          align="center"
          style={{ color: 'var(--color-blue)' }}
        >
          처리: {Format.number(sumSeq)} 건
        </FlexLayout>
      );
    },
    trail: (_, scope) => (
      <FlexLayout
        justify="center"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {scope?.state.compcnt_tot}
      </FlexLayout>
    ),
  },
  {
    id: 'recepernm',
    text: '배정자',
    width: 80,
  },
  {
    id: 'seqnm',
    text: '처리',
    width: 60,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.seqnm}
      </FlexLayout>
    ),
  },
  {
    id: 'pernm',
    text: '처리자',
    width: 80,
    sum: (x, data) => {
      const sumSeq = Sum.groupValue(data, 'seq', x, '', ['actnm']);
      return (
        <FlexLayout
          justify="center"
          align="center"
          style={{ color: 'var(--color-red)' }}
        >
          미처리: {Format.number(sumSeq)} 건
        </FlexLayout>
      );
    },
    trail: (_, scope) => (
      <FlexLayout
        justify="center"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {scope?.state.notcnt_tot}
      </FlexLayout>
    ),
  },
  {
    id: 'pernm2',
    text: '처리자2',
    width: 80,
  },
  {
    id: 'contnm',
    text: '고장내용',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.contnm}
      </FlexLayout>
    ),
  },
  {
    id: 'contremark',
    text: '고장내용상세',
    width: 200,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.contremark}
      </FlexLayout>
    ),
  },
  {
    id: 'resunm',
    text: '처리내용',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.resunm}
      </FlexLayout>
    ),
  },
  {
    id: 'resuremark',
    text: '처리내용상세',
    width: 200,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.resuremark}
      </FlexLayout>
    ),
  },
  {
    id: 'remonm',
    text: '고장요인',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.remonm}
      </FlexLayout>
    ),
  },
  {
    id: 'remoremark',
    text: '고장원인상세',
    width: 200,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.remoremark}
      </FlexLayout>
    ),
  },
  {
    id: 'facnm',
    text: '고장원인',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.facnm}
      </FlexLayout>
    ),
  },
  {
    id: 'greginm',
    text: '고장부위',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.greginm}
      </FlexLayout>
    ),
  },
  {
    id: 'reginm',
    text: '고장부위상세',
    width: 200,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.reginm}
      </FlexLayout>
    ),
  },
  {
    id: 'resultnm',
    text: '처리방법',
    width: 100,
  },
  {
    id: 'arrivdate',
    text: '도착일자',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {Date8.withDash(x.arrivdate)}
      </FlexLayout>
    ),
  },
  {
    id: 'arrivtime',
    text: '도착시간',
    width: 80,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.arrivtime.substr(0, 2)}:{x.arrivtime.substr(2, 2)}
      </FlexLayout>
    ),
  },
  {
    id: 'compdate',
    text: '완료일자',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {Date8.withDash(x.compdate)}
      </FlexLayout>
    ),
  },
  {
    id: 'comptime',
    text: '완료시간',
    width: 80,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.comptime.substr(0, 2)}:{x.comptime.substr(2, 2)}
      </FlexLayout>
    ),
  },
  {
    id: 'resutime',
    text: '대응(분)',
    width: 80,
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {x.resutime}
      </FlexLayout>
    ),
  },
  {
    id: 'resulttime',
    text: '처리(분)',
    width: 80,
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {x.resulttime}
      </FlexLayout>
    ),
  },
  {
    id: 'stoptime',
    text: '비운행(분)',
    width: 80,
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {x.stoptime}
      </FlexLayout>
    ),
  },
  {
    id: 'reyyyymm',
    text: '설치년도',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {Date8.withDash(x.reyyyymm)}
      </FlexLayout>
    ),
  },
  {
    id: 'contgubun',
    text: '계약구분',
    width: 80,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {contgubuns.filter((y) => y.value === x.contgubun)[0]?.remark}
      </FlexLayout>
    ),
  },
  {
    id: 'recetelnum',
    text: '고객안심문자(신고자)',
    width: 120,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.recetelnum}
      </FlexLayout>
    ),
  },
];

export default Act;
